import { render } from "./CIS-CTA-Carousel-Item-CTA.vue?vue&type=template&id=18b97272&scoped=true"
import script from "./CIS-CTA-Carousel-Item-CTA.vue?vue&type=script&lang=js"
export * from "./CIS-CTA-Carousel-Item-CTA.vue?vue&type=script&lang=js"

import "./CIS-CTA-Carousel-Item-CTA.vue?vue&type=style&index=0&id=18b97272&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b97272"]])

export default __exports__